import React from 'react'
import { Dashboard } from './components/Dashboard'
import { LoadingState } from './components/LoadingState'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { track } from '@utils/tracking'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      refetchOnMount: false,
      useErrorBoundary: true
    },
  },
})

export const OrganizationDashboard = ({ organization, initialData, incognito = false }) => {
  const reportReady = initialData.data == undefined ? false : true

  track('Organization Dashboard', { report_ready: reportReady })

  if (!reportReady) {
    return (
      <QueryClientProvider client={queryClient}>
        <LoadingState organization_id={organization.id} />
      </QueryClientProvider>
    )
  }

  return (
    <QueryClientProvider client={queryClient}>
      <Dashboard organization={organization} initialData={initialData} incognito={incognito} />
    </QueryClientProvider>
  )
}
